import {actions} from "../actions/savedSearchActions";

export default (state =
                    {
                        selectedSearch: null
                    }, action) => {

    state = { ...state };

    if (action.type === actions.SET_SELECTED_SEARCH) {
        state.selectedSearch = action.payload;
        return state;
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./app/reducers/savedSearchReducer.ts